/** Admin布局 — 240px侧边栏 + 内容区 */
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Sidebar from '@/components/admin/Sidebar';
import TopBar from '@/components/admin/TopBar';
import TodoCountProvider from '@/components/common/TodoCountProvider';

export default function AdminLayout() {
  return (
    <TodoCountProvider>
      <Box sx={{ display: 'flex', height: '100vh' }}>
        <Sidebar />
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <TopBar />
          <Box
            component="main"
            sx={{
              flex: 1,
              overflow: 'auto',
              p: 3,
              backgroundColor: '#F5F7FA',
            }}
          >
            <Outlet />
          </Box>
        </Box>
      </Box>
    </TodoCountProvider>
  );
}
